<template>
  <a-dropdown
    placement="topRight"
    :trigger="['click']">
    <template #overlay>
      <chrome-picker
        ref="colorPicker"
        v-model="colors"
        @input="onChangeColor"
      />
    </template>

    <span class="icp_clicker">
      <slot name="icon" />
    </span>
  </a-dropdown>
</template>

<script>
import ADropdown from 'ant-design-vue/lib/dropdown'
import { Chrome } from 'vue-color'

export default {
  name: 'color-picker',
  components: {
    'chrome-picker': Chrome,
    ADropdown,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      placement: 'topRight',
      colors: this.value,
    }
  },
  methods: {
    onChangeColor (color) {
      this.$emit('change', color.hex)
    },
  },
}
</script>

<style scoped lang="scss">
  @import '~@scss/variables';
  @import '~ant-design-vue/lib/dropdown/style/index.css';

  .icp_clicker {
    font-size: 1.4em;
    cursor: pointer;
    line-height: normal;
    width: 1.8em;
    display: inline-block;
    color: $_black;
  }
</style>
